<template>
<div>
    <div class="card carde">

        <div class="card-body">

            <div v-if="$store.state.loading" class="d-flex flex-column align-items-center justify-content-center">

                <az-loading msg="Aguarde..." />

                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status" v-if="1 == 0">
                    <span class="sr-only">Loading...</span>
                </div>

            </div>

            <div v-else class="d-flex flex-column align-items-center justify-content-center w3-animate-opacity">

                <template v-if="feriado">
                    <i class="fas fa-glass-cheers fa-w-12 fa-7x my-3"></i>    
                    <h3 class="my-3 text-center">{{ feriado.st_descricao }}</h3>    
                </template>

                <template v-else-if="bloqueio">

                    <i class="fa fa-ban fa-w-12 fa-7x my-3"></i>
                    <h3 class="my-3 text-center">
                        {{ bloqueio.bloqueio_motivo.search }} 
                        <span v-if="bloqueio.st_observacao">({{ bloqueio.st_observacao }})</span>
                    </h3>    

                </template>

                <template v-else>

                    <i :class="icon ? icon : 'far fa-file-alt'" class="fa-w-12 fa-7x my-3" v-if="icon != 'no'"></i>

                    <h3 class="my-3 text-center" v-if="!$props.action || !$props.msg || $props.action != $props.msg">
                        {{ $props.msg ? $props.msg : 'Nenhum item registrado.' }}
                    </h3>

                    <button type="button" class="btn btn-primary my-3" 
                        :class="$props.action == $props.msg ? 'btn-lg' : ''"
                        @click="call_to_action()" v-if="$props.action"
                        :disabled="$store.state.loading">
                        {{ $props.action }}
                    </button>

                </template>

            </div>

        </div>

    </div>

</div>
</template>

<script>
import AzLoading from './AzLoading.vue';

export default {
    data () { 
        return {};
    },
    components: {
        AzLoading,
    },
    props: ['msg', 'action', 'path', 'loading', 'method', 'icon', 'feriado', 'bloqueio'],
    methods: { 
        call_to_action () { 
            this.method ();
        }
    }
}
</script>
